var Search = function () {

    var query = "";

    this.init = function () {

        Array.prototype.move = function (from, to) {
            this.splice(to, 0, this.splice(from, 1)[0]);
            return this;
        };

        if (window.localStorage.getItem("search")) {
            var cache = window.localStorage.getItem("search").split(",");
            var html = "";
            var virgula = " ";
            
            if (cache.length > 1) { virgula = ", "; }
            
            for (i = 0; i < cache.length; i++) {

                if (i == cache.length - 1) { virgula = " "; }

                html += "<a href='?s=" + cache[i] + "'>" + cache[i] + "</a>" + virgula;
            }

            $(".result-search-legend-result").show();
            $(".result-search-legend-result").find("p").append(html);
        }
        else {
            $(".result-search-legend-result").hide();
        }

        $(".talkSpecialistComponent form").submit(function (e) {
            e.preventDefault();
            query = $(this).find("input").val();
            getResults(query);
        });

        if ($(".talkSpecialistComponent").length > 0) {

            query = new URL(window.location.href).searchParams.get("s");

            if (!query) {
                window.location.href = "/";
            }
            else {
                getResults(query);
            }
        }

        $(".load-more-product-search").on("click", function (e) {

            e.preventDefault();

            var Component = $(this);
            var Limiter = 3;
            var TotalAmount = $(".mobil-products [data-component='product-item']").length;

            Component.addClass('loading');

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Search/SearchMoreProducts",
                data: JSON.stringify({ "Query": query, "Limiter": Limiter, "TotalAmount": TotalAmount }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    Component.removeClass('loading');

                    if (response.SearchProductList.length > 0)
                        $(getProducts(response.SearchProductList)).insertBefore(".load-more-product-search");

                    TotalAmount = $(".mobil-products [data-component='product-item']").length;

                    if (response.ProductListTotalAmount <= TotalAmount) {
                        $(".load-more-product-search").hide();
                    }
                },
                error: function (e) {

                }
            });
        });

        $(".loadMoreContentSearch").on("click", function (e) {

            e.preventDefault();

            var Component = $(this);
            var Limiter = 3;
            var TotalAmount = $(".mobil-content [data-component='card-item']").length;

            Component.addClass('loading');

            $.ajax({
                type: "POST",
                url: "/umbraco/surface/Search/SearchMoreContent",
                data: JSON.stringify({ "Query": query, "Limiter": Limiter, "TotalAmount": TotalAmount }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (response) {

                    Component.removeClass('loading');

                    if (response.SearchContentList.length > 0)
                        $(".mobil-content").append(getCards(response.SearchContentList));

                    TotalAmount = $(".mobil-content [data-component='card-item']").length;

                    if (response.ContentListTotalAmount <= TotalAmount) {
                        $(".loadMoreContentSearch").hide();
                    }
                },
                error: function (e) {

                }
            });
        });

        $(".result-search-legend-result").on("click", ".cache-click", function (e) {
            getResults($(this).text());
        });
    }

    var getResults = function (query) {

        saveCache(query);

        $(".mobil-products .result-search-product").remove();
        $(".mobil-content .row").remove();

        $(".productFail p").hide();
        $(".contentFail p").hide();

        $(".load-more-product-search").hide();
        $(".loadMoreContentSearch").hide();

        $("#productLoader").show();
        $("#contentLoader").show();

        $.ajax({
            type: "POST",
            url: "/umbraco/surface/Search/Search",
            data: JSON.stringify({ "Query": query }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            success: function (response) {

                $(".searchQuery").text('"' + query + '"');

                $("#productLoader").hide();
                $("#contentLoader").hide();

                if (response.SearchProductList.length > 0) {
                    $(getProducts(response.SearchProductList)).insertBefore(".load-more-product-search");

                    if (response.ProductListTotalAmount > 3) {
                        $(".load-more-product-search").show();
                    }
                }
                else {
                    $(".productFail p").show();
                }

                if (response.SearchContentList.length > 0) {
                    $(".mobil-content").append(getCards(response.SearchContentList));

                    if (response.ContentListTotalAmount > 3) {
                        $(".loadMoreContentSearch").css("display", "block");
                    }
                }
                else {
                    $(".contentFail p").show();
                }

                $("[data-component='inline-search'] form").find("input").val('');
            },
            error: function (e) {

            }
        });
    };

    var getProducts = function (productList) {

        var html = "";

        for (var i = 0; i < productList.length; i++) {

            var Product = productList[i];

            html += '<div data-component="product-item" class="result-search-product">';
            html += '   <div class="img-holder">';
            html += '       <img src="' + Product.Image + '" alt="' + Product.ImageAltText + '">';
            html += '   </div>';
            html += '   <div class="text-block">';

            if (Product.ButtonURL) {
                html += '   <a href="' + Product.ButtonURL + '"><h3 class="title">' + Product.Title + '</h3></a>';
            }
            else {
                html += '   <h3 class="title">' + Product.Title + '</h3>';
            }

            html += '       <div class="description">';
            html +=             Product.Description;
            html += '       </div>';

            if (Product.Categories) {

                html += '   <ul class="category-list">';

                for (var j = 0; j < Product.Categories.length; j++) {
                    html += '   <li><span>' + Product.Categories[j] + '</span></li>';
                }

                html += '   </ul>';
            }

            html += '   </div>';
            html += '</div>';
        }

        return html;
    };

    var getCards = function (cardList) {

        var html = "";

        for (var i = 0; i < cardList.length; i++) {

            var Card = cardList[i];

            if (i % 3 == 0) html += '<div class="row">';

            html += '<div class="col-md-4 col-sm-6 col-xs-12">';
            html += '   <div data-component="card-item">';
            html += '       <div class="img-holder">';
            html += '           <img src="' + Card.Image + '" alt="' + Card.ImageAltText + '">';
            html += '       </div>';
            html += '       <div class="content content-inner content-news">'
            html += '           <div class="infos">';
            html += '               <span class="type">' + Card.TopText + '</span>';
            html += '               <h3 class="title">' + Card.Title + '</h3>';
            html += '               <div class="description">';
            html +=                     Card.Description;
            html += '               </div>';

            if (Card.ButtonText) {
                html += '           <a href="' + Card.URL + '" class="btn-more">' + Card.ButtonText + '</a>';
            }

            html += '           </div>';
            html += '       </div>';
            html += '   </div>';
            html += '</div>';

            if (i % 3 == 2) html += '</div>';
        }

        //if (html.substr(-12) != '</div></div>') html += '</div>';

        return html;
    };

    var saveCache = function (query) {

        var cache;
        var corte = 4;

        if (window.localStorage.getItem("search")) {
            cache = window.localStorage.getItem("search").split(",");
        }

        if (cache) {

            if (cache.length < 4) {
                corte = cache.length;
            }

            if (cache.indexOf(query) > -1) {
                cache = cache.move(cache.indexOf(query), 0);
                cache = cache.slice(0, corte + 1);
            }
            else {
                cache = query + "," + cache.slice(0, corte);
            }
        }
        else {
            cache = query;
        }

        localStorage.setItem("search", cache);

        cache = window.localStorage.getItem("search").split(",");

        var html = "";
        var virgula = " ";

        if (cache.length > 1) { virgula = ", "; }

        for (i = 0; i < cache.length; i++) {

            if (i === cache.length - 1) { virgula = " "; }

            html += "<a class='cache-click'>" + cache[i] + "</a>" + virgula;
        }

        $(".result-search-legend-result").find("p").empty();
        $(".result-search-legend-result").find("p").append("Suas buscas mais recentes: " + html);
        $(".result-search-legend-result").show();
    };

    return this.init();
}